'use client';

import { processCommonProps } from "./processCommonProps.js";
function processAnchorProps(props) {
  const {
    target,
    propsToSpread: { href, ref, type, ...propsToSpread },
    ...p
  } = processCommonProps(props);
  return {
    ...p,
    ref,
    href,
    target,
    propsToSpread
  };
}
export {
  processAnchorProps
};
